/** Unread count from POST /admin/login and POST /admin/partner-login payloads. */
export const pickNotificationCount = (payload = {}) => {
  const raw =
    payload.notificationCount ??
    payload.unreadNotificationCount ??
    payload.user?.notificationCount ??
    payload.user?.unreadNotificationCount;

  const n = Number(raw);
  return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
};
